"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { MarketingBrandId } from "~/lib/marketing-brand";

const SiteGlueMarketingBrandContext = createContext<MarketingBrandId | null>(null);

/** Set on siteglue.ai in root layout so DemoCTA SSR/hydration uses Book a Demo (not Inbound defaults). */
export function SiteGlueMarketingBrandProvider({ children }: { children: ReactNode }) {
  return (
    <SiteGlueMarketingBrandContext.Provider value="siteglue">
      {children}
    </SiteGlueMarketingBrandContext.Provider>
  );
}

export function useSiteGlueMarketingBrand(): MarketingBrandId | null {
  return useContext(SiteGlueMarketingBrandContext);
}
